import { DiscoveryState } from '../domain/enums.js';
import { z } from '../zod.js';
import { Uuid } from './common.js';
/** A secret's discovery state, as the editor shows it on the secret's chip. */
export const SecretStateV1 = z.strictObject({
    secretId: Uuid,
    label: z.string(),
    state: DiscoveryState,
});
//# sourceMappingURL=secrets.js.map